import { useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { appSnapshotEvent, otherAppLinks, readAppSnapshot, type ProductCode } from '../services/appAccessSnapshot';
export function YourAppsMenu({ current, businessId }: { current: ProductCode; businessId?: string | null }) {
  const [snapshot, setSnapshot] = useState(readAppSnapshot);
  useEffect(() => {
    const update = () => setSnapshot(readAppSnapshot());
    window.addEventListener(appSnapshotEvent, update);
    return () => window.removeEventListener(appSnapshotEvent, update);
  }, []);
  const links = otherAppLinks(snapshot, current, businessId);
  if (!links.length) return null;
  return <>
    <Dropdown.Divider />
    <Dropdown.Header>Your apps</Dropdown.Header>
    {links.map(app => <Dropdown.Item key={app.product} as="a" href={app.url} target="_blank" rel="noopener noreferrer">
      Open {app.name} <span aria-hidden="true">↗</span>
    </Dropdown.Item>)}
  </>;
}
